<template>
  <li class="d-search-result">
    <DSearchResultGenre
      v-if="resultType === 'genre'"
      :result="result"
      :result-url="resultUrl"
    />

    <DSearchResultBook
      v-if="resultType === 'book' || resultType === 'external_book'"
      :result="result"
      :result-url="resultUrl"
    />

    <DSearchResultUser
      v-if="resultType === 'user'"
      :result="result"
      :result-url="resultUrl"
    />
  </li>
</template>

<script>
import DSearchResultBook from './d-search-result-book/d-search-result-book.vue';
import DSearchResultGenre from './d-search-result-genre/d-search-result-genre.vue';
import DSearchResultUser from './d-search-result-user/d-search-result-user.vue';

import URLS from '@d-shared/urls/urls';

export default {
  components: {
    DSearchResultBook,
    DSearchResultGenre,
    DSearchResultUser,
  },
  props: {
    result: {
      type: Object,
      required: true,
    },
    resultType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    resultUrl: '',
  }),
  mounted() {
    this.setResultUrl();
  },
  methods: {
    setResultUrl() {
      let resultUrl = '';

      switch (this.resultType) {
        case 'book':
        case 'external_book':
          resultUrl = URLS.app.book.replace('<book-slug>', this.result.id);
          break;
        case 'genre':
          resultUrl = URLS.app.genre.replace('<genre-slug>', this.result.id);
          break;
        case 'user':
          resultUrl = URLS.app.userProfile.entry.replace('<user-slug>', this.result.id);
          break;
        default:
          break;
      }

      this.$set(this, 'resultUrl', resultUrl);
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.d-search-result {
  a {
    align-items: center;
    color: getColor($black);
    cursor: pointer;
    display: flex;
    font-weight: normal;
    padding: $_1em 0;

    &:hover {
      background-color: getColor($grey);
    }
  }

  .dui-book-cover,
  img.user-avatar {
    flex: none;
    margin-right: $_1em;
  }

  .result-info {
    display: flex;
    flex: 0 1 auto;
    flex-direction: column;
    line-height: $_2em;
    min-width: 0;

    .result-label,
    .more-info {
      display: block;

      @include ellipsis();
    }

    .result-label {
      flex: 1;
      font-size: $font-size-sm;
    }

    .more-info {
      color: getColor($grey, dark);
      font-size: $font-size-xs;
    }
  }
}
</style>
